/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ServiceDto } from './ServiceDto';
import {
    ServiceDtoFromJSON,
    ServiceDtoFromJSONTyped,
    ServiceDtoToJSON,
} from './ServiceDto';

/**
 * 
 * @export
 * @interface ServicesDto
 */
export interface ServicesDto {
    /**
     * The services.
     * @type {Array<ServiceDto>}
     * @memberof ServicesDto
     */
    items: Array<ServiceDto>;
}

/**
 * Check if a given object implements the ServicesDto interface.
 */
export function instanceOfServicesDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

export function ServicesDtoFromJSON(json: any): ServicesDto {
    return ServicesDtoFromJSONTyped(json, false);
}

export function ServicesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServicesDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ServiceDtoFromJSON)),
    };
}

export function ServicesDtoToJSON(value?: ServicesDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(ServiceDtoToJSON)),
    };
}

